import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <div className="bg-white ">
        <div className="px-4 pb-8 pt-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
          <div className="grid grid-cols-1 gap-5  lg:grid-cols-3 md:grid-cols-2 py-2">
            <div>
              <p className="font-medium tracking-wide text-black">Links</p>
              <ul className="mt-2 space-y-2">
                <li>
                  <Link
                    to={"/"}
                    className="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200"
                  >
                    Home
                  </Link>
                </li>

                <li>
                  <Link
                    to={"/contact"}
                    className="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200"
                  >
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/termsandcondition"}
                    className="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200"
                  >
                    Terms and Conditions
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/privacypolicy"}
                    className="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-200"
                  >
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <p className="font-medium tracking-wide text-black">Address</p>
              <p className="text-gray-500 mt-2 space-y-2 lg:max-w-xs">
                P.No. 155,Part 156 P, Farzanguda, Secunderabad, Alwal, Tirumalagiri, HYDERABAD,TELENGANA 500010
              </p>
            </div>
            <div>
              <p className="font-medium tracking-wide text-black">Contact Us</p>
              <p className="text-gray-500 mt-2 space-y-2">
                support@minibrain.net
              </p>
            </div>
          </div>

          <div className="flex flex-col justify-between pt-5 pb-10 border-t border-gray-800 sm:flex-row">
            <p className="text-sm text-gray-500">© Copyright 2023 Medshow</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
